import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import SimuladorNumericInput from "./SimuladorNumericInput";
import { truncar } from "../../Helpers/Truncar";


export const SimuladorPortafolioCobranza = ({ rango = null, saldo = 0, setPorcentaje, incentivoRecuperacion = 0, setIncentivosPortafolio, handleChangePortafolio, saldoPortafolio, porcentajeAtraso }) => {

    const [state, setState] = useState({
        meta: 0,
        real: 0,
        cumplimiento: 0,
        porcentaje: 0,
        incentivo: 0,
    });
    const handleChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
    };
    useEffect(() => {
        if (Number(state.meta !== 0) && Number(state.real !== 0 && Number(saldo) !== 0)) {
            const cumplimiento = truncar((Number(state.meta) / Number(saldo)) * 100);
            var porcentaje = 0;
            var incentivo = 0;

            const porcentajeAtraso = state.real / saldo * 100

            setPorcentaje(porcentajeAtraso)

            porcentaje = cumplimiento - porcentajeAtraso;
            

            if (rango !== null) {
                rango.forEach((index) => {
                    if (index.minimo <= porcentaje && index.maximo >= porcentaje) {
                        incentivo = index.porcentaje * 100;
                    }
                });
            }

            setState({
                ...state,
                cumplimiento,
                porcentaje: porcentaje,
                incentivo,
            });

            setIncentivosPortafolio(incentivo)
        }
    }, [state.meta, state.real, saldo, incentivoRecuperacion]);
    return (
        <div className="simulador-incentivo-vendedor-input">
            <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">Saldo vencido inicio</div>
                    <SimuladorNumericInput
                        name="meta"
                        label=""
                        value={state.meta}
                        disabled={false}
                        onChange={handleChange}
                    />
                </div>
                <div className="input-section">
                    <div className="input-title-label">Saldo vencido final</div>
                    <SimuladorNumericInput
                        name="real"
                        label=""
                        value={state.real}
                        disabled={false}
                        onChange={handleChange}
                    />
                </div>
            </div>
            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label">  Saldo total de portafolio al inicio</div>
                    <SimuladorNumericInput
                        name="saldo"
                        label=""
                        value={saldoPortafolio}
                        disabled={false}
                        onChange={handleChangePortafolio}
                        icono="pesos"
                    />
                </div>
            </div>
            <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">% atraso al inicio</div>
                    <SimuladorNumericInput
                        name="cumplimiento"
                        label=""
                        value={state.cumplimiento}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>

                <div className="input-section">
                    <div className="input-title-label">% atraso al final</div>
                    <SimuladorNumericInput
                        name="cumplimiento"
                        label=""
                        value={porcentajeAtraso}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>
            </div>
            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label">% mejora de portafolio</div>
                    <SimuladorNumericInput
                        name="porcentaje"
                        label=""
                        value={state.porcentaje}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>
            </div>

            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label">Tu incentivo es de:</div>
                    <SimuladorNumericInput
                        name="incentivo"
                        label=""
                        value={state.incentivo}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>
            </div>
        </div>
    );
};
